import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import scroller from 'react-scroll/modules/mixins/scroller';
import FacetList from 'shared/components/hawksearch/components/ui/Facets/FacetList';
import { ResultsProps } from 'shared/components/hawksearch/components/ui/Results/Results';
import VisuallyHiddenAnnouncementContext from 'shared/components/VisuallyHiddenAnnouncementContext';
// #region HCL
import ResultsHCL from '../../shared/components/hawksearch/components/ui/Results/Results.HCL';
import RocResultItemHCL from './components/RocResultItem.HCL';
// #region

export type ScrollToResults = {
	scrollToResults: (controlChanged: string) => void;
};

/**
 * Interstitial component for enabling the visually hidden announcement.
 *
 * @export
 * @returns
 */
// #region HCL - added option to change resultItem
export default function FacetsAndResults({ resultItem = RocResultItemHCL }: ResultsProps) {
	// #endregion
	const { t } = useTranslation();
	const { setAlert } = useContext(VisuallyHiddenAnnouncementContext);

	function scrollToResults(controlChanged: string) {
		scroller.scrollTo('hawk-facet-rail__scroll-to-facets', {
			duration: 400,
			smooth: true,
		});

		const focusEl = document.getElementById('hawk-sort-by');

		focusEl?.focus();

		setTimeout(() => {
			setAlert(t(`Updated results based on changing ${controlChanged}. Scrolled to the top of results.`));
		}, 500);
	}

	return (
		<>
			<FacetList scrollToResults={scrollToResults} />

			<ResultsHCL resultItem={resultItem} scrollToResults={scrollToResults} />
		</>
	);
}
